module.exports = __webpack_public_path__ + "static/chiara-bcb296e87647355917d95815fe85f77e.png";